import React from 'react'
import './RepaymentList.css'

const RepaymentListUI = ({context, repaymentList, loanCount}) =>
  <div className='rp_l'>
    <h3>Repayments</h3>
    <table><tbody>
      <tr>
        <td className='g_text_center'><b>Scheduled</b></td>
        <td className='g_text_center'><b>Interest</b></td>
        <td className='g_text_center'><b>Principal</b></td>
        <td className='g_text_center'><b>EMI</b></td>
        <td className='g_text_center'><b>EMI Tax</b></td>
        <td className='g_text_center'><b>Late Int</b></td>
        {/*<td className='g_text_center'><b>Late Int Tax</b></td>*/}
        <td className='g_text_center'><b>DSRA Int</b></td>
        <td className='g_text_center'><b>Default Int</b></td>
        <td className='g_text_center'><b>Payable</b></td>
        <td className='g_text_center'><b>Paid</b></td>
        <td className='g_text_center'><b>Paid date</b></td>
        <td className='g_text_center'><b>Status</b></td>
        <td className='g_text_center'><b>Balance</b></td>
      </tr>

      {
        repaymentList.map((repayment, i) =>
          <tr key={i}>
            <td className='g_text_right' valign='top'>
              {repayment.scheduledDateF1}
              <BreakupUI repayment={repayment} loanCount={loanCount} field='loanName' />
            </td>
            <td className='g_text_right'><span className='g_m_left_50'>
              {repayment.interestF2}<br/>
              <BreakupUI repayment={repayment} loanCount={loanCount} field='interestF2' />
            </span></td>
            <td className='g_text_right'><span className='g_m_left_50'>
              {repayment.principalF2}
              <BreakupUI repayment={repayment} loanCount={loanCount} field='principalF2' />
            </span></td>
            <td className='g_text_right'><span className='g_m_left_50'>
              {repayment.emiF2}
              <BreakupUI repayment={repayment} loanCount={loanCount} field='emiF2' />
            </span></td>
            <td className='g_text_center g_m_left_50'><div className='g_m_left_50'>
              {
                repayment.emiTaxList.map((tax, j) =>
                  <span key={j}>
                    { j != 0 && <>+</>}
                    {tax.amountF2}
                  </span>
                )
              }
              {
                repayment.loanList.length > 1 &&
                repayment.loanList.map((loan, j) =>
                  <div key={j} className='g_muted'>
                    {
                      loan.emiTaxList.length === 0 &&
                      <span></span>
                    }
                    {
                      loan.emiTaxList.map((tax, k) =>
                        <span key={k}>
                          { k != 0 && <>+</>}
                          {tax.amountF2}
                        </span>
                      )
                    }
                  </div>
                )
              }
            </div></td>
            <td className='g_text_right'><span className='g_m_left_50'>
              {repayment.lateInterestF2}
              <BreakupUI repayment={repayment} loanCount={loanCount} field='lateInterestF2' />
            </span></td>
            {/*<td className='g_text_right'><div className='g_m_left_50'>
              {
                repayment.lateInterestTaxList.map((tax, j) =>
                  <span key={j}>
                    { j != 0 && <>+</>}
                    {tax.amountF2}
                  </span>
                )
              }
              {
                repayment.loanList.length > 1 &&
                repayment.loanList.map((loan, j) =>
                  <div key={j} className='g_muted'>
                    {
                      loan.lateInterestTaxList.length === 0 &&
                      <span>-</span>
                    }
                    {
                      loan.lateInterestTaxList.map((tax, k) =>
                        <span key={k}>
                          { k != 0 && <>+</>}
                          {tax.amountF2}
                        </span>
                      )
                    }
                  </div>
                )
              }
            </div></td>*/}
            <td className='g_text_right'><span className='g_m_left_50'>
              {repayment.drsaDipInterestF4}
              <BreakupUI repayment={repayment} loanCount={loanCount} field='drsaDipInterestF4' />
            </span></td>
            <td className='g_text_right'><span className='g_m_left_50'>
              {repayment.defaultInterestF4}
              <BreakupUI repayment={repayment} loanCount={loanCount} field='defaultInterestF4' />
            </span></td>
            <td className='g_text_right'><span className='g_m_left_50'>
              {repayment.emiWithLateInterestAndTaxF2}
              <BreakupUI repayment={repayment} loanCount={loanCount} field='emiWithLateInterestAndTaxF2' />
            </span></td>
            <td className='g_text_right'><span className='g_m_left_50'>
              {repayment.amountPaidF5}
              <BreakupUI repayment={repayment} loanCount={loanCount} field='amountPaidF5' />
            </span></td>
            <td className='g_text_right'><span className='g_m_left_50'>
              {repayment.paymentDateF1}
              <BreakupUI repayment={repayment} loanCount={loanCount} field='paymentDateF1' />
            </span></td>
            <td className='g_text_right'><span className='g_m_left_50'>
              {repayment.status}
              <BreakupUI repayment={repayment} loanCount={loanCount} field='status' />
            </span></td>
            <td className='g_text_right'><span className='g_m_left_50'>
              {repayment.balanceF2}
              <BreakupUI repayment={repayment} loanCount={loanCount} field='balanceF2' />
            </span></td>
          </tr>
        )
      }
    </tbody></table>
  </div>

  const BreakupUI = ({repayment, field, loanCount}) =>
    <>
      {
        loanCount > 1 &&
        repayment.loanList.map((loan, j) =>
          <div key={j} className='g_muted'>{loan[field] ? loan[field] : '.'}</div>
        )
        /* without the dot, the values are pushed up to previous row */
      }
    </>

export default RepaymentListUI
